<!-- 库房报损 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                            @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <!-- 主要信息 -->
                            <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                                <el-form label-width="110px" id="mainInfo" class="baseForm" :show-message="false" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                                    <el-row v-if="dataActionBox.actionType != 2">
                                        <el-form-item :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1"
                                                      :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <el-tooltip class="item"
                                                        :disabled="(sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false) || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)"
                                                        placement="bottom-start">
                                                <df-date :isdisabled="formOneValue.isChange == 0" v-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                         v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <!-- 检索方案 -->
                                                <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                          :id="formOneValue.entityField"
                                                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                          :disabled="formOneValue.isChange == 0 || (sendDataInfo.desuWoplandetails.length > 0 && formOneValue.isUpdate == 0) ? true : false">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                               icon="el-icon-search" :disabled="formOneValue.isChange == 0 || (sendDataInfo.desuWoplandetails.length > 0 && formOneValue.isUpdate == 0) ? true : false">
                                                    </el-button>
                                                </el-input>
                                                <el-select @change="$forceUpdate()" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'"
                                                           :disabled="formOneValue.isChange == 0 || (sendDataInfo.desuWoplandetails.length > 0 && formOneValue.isUpdate == 0)"
                                                           v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                    </el-option>
                                                </el-select>
                                                <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                                          @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                          :disabled="formOneValue.isChange == 0 || (sendDataInfo.desuWoplandetails.length > 0 && formOneValue.isUpdate == 0)"></el-input>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-row>
                                    <el-row v-if="dataActionBox.actionType == 2">
                                        <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                            <span v-if="formOneValue.isRift == 1">
                                                <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                       sendDataInfo[formOneValue.entityField]
                                    }}</a>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'date'">
                                                <span v-if="sendDataInfo[formOneValue.entityField]">
                                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                </span>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                {{ getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField,
                                       formOneValue.fieldType, formOneValue.formatterContent) }}
                                            </span>
                                            <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                                       sendDataInfo[formOneValue.entityField] == 1 ? "是" : "否" }}</span>
                                            <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                                <!-- 明细 -->
                                <el-form :inline="true" size="mini">
                                    <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                        <el-button type="primary" size="mini" @click="addDetails('sendDataInfo')">新增</el-button>
                                        <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                        </el-button>
                                    </div>
                                    <el-table size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.desuWoplandetails" border style="width: 100%" :height="mxHeight">
                                        <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                                         v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                            <template slot-scope="scope">
                                                <!-- 商品 -->
                                                <div v-if="dataActionBox.actionType != 2">
                                                    <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName'" v-model.number="sendDataInfo.desuWoplandetails[scope.$index].bgmName"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)"
                                                              clearable>
                                                        <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)" slot="append"
                                                                   icon="el-icon-search"></el-button>
                                                    </el-input>
                                                    <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'search'"
                                                              v-model.number="sendDataInfo.desuWoplandetails[scope.$index][formOneValue.entityField]"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)"
                                                              clearable>
                                                        <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)" slot="append"
                                                                   icon="el-icon-search"></el-button>
                                                    </el-input>
                                                    <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'string' && formOneValue.isChange == 1"
                                                              @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model="sendDataInfo.desuWoplandetails[scope.$index][formOneValue.entityField]"
                                                              type="text">
                                                    </el-input>
                                                    <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'number' && formOneValue.isChange == 1"
                                                              @input="calculatePrice(formOneValue.entityField, scope.$index)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                              v-model="sendDataInfo.desuWoplandetails[scope.$index][formOneValue.entityField]" type="number">
                                                    </el-input>
                                                    <df-date :ref="formOneValue.entityField" :isdisabled="formOneValue.isChange == 0" v-else-if="formOneValue.fieldType == 'date' && formOneValue.isChange == 1"
                                                             @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                             v-model="sendDataInfo.desuWoplandetails[scope.$index][formOneValue.entityField]"></df-date>
                                                    <el-select @change="$forceUpdate()" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter' && formOneValue.isChange == 1"
                                                               v-model="sendDataInfo.desuWoplandetails[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(sendDataInfo.desuWoplandetails[scope.$index].formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                        {{
                                             getValue(sendDataInfo.desuWoplandetails[scope.$index][formOneValue.entityField],
                                                formOneValue.entityField, formOneValue.fieldType,
                                                formOneValue.formatterContent) }}
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="scope.row[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <span v-else>
                                                        {{ sendDataInfo.desuWoplandetails[scope.$index][formOneValue.entityField] }}
                                                    </span>
                                                </div>
                                                <div v-else>
                                                    <span v-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="scope.row[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                        {{
                                             getValue(sendDataInfo.desuWoplandetails[scope.$index][formOneValue.entityField],
                                                formOneValue.entityField, formOneValue.fieldType,
                                                formOneValue.formatterContent) }}
                                                    </span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(scope.row[formOneValue.riftField])">{{
                                             scope.row[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else>
                                                        {{ sendDataInfo.desuWoplandetails[scope.$index][formOneValue.entityField] }}
                                                    </span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                        @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 检索方案弹窗 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "suWoplanAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            ormId: '',
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            detaislDataInfo: {},
            selectGoodsInfo: "",
            showTabs: "",
            formDataList: [],
            selectedDetailsIndex: 0, //选择索引
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: [],
            inputel: [],
            //-----------------------
            parentSearchData: {},
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: "0",
            seId: 0,
            sField: "",
            seType: "",
            seIndex: 0,
            fField: "",
            //------------------拦截
            dialogList: [],
            showDialog: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.desuWoplandetails": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalCount = 0;//总条目数
                this.sendDataInfo.totalMoney = 0;// 总金额
                this.sendDataInfo.totalNumber = 0; // 总数量
                newValue.forEach((item, index) => {
                    this.sendDataInfo.totalMoney = NP.plus(
                        parseFloat(this.sendDataInfo.totalMoney),
                        parseFloat(item.psmoney)
                    );
                    this.sendDataInfo.totalNumber = NP.plus(
                        parseFloat(this.sendDataInfo.totalNumber),
                        parseFloat(item.orderNum)
                    );
                })
                this.sendDataInfo.totalCount = this.sendDataInfo.desuWoplandetails.length
            },
            deep: true
        }
    },
    //方法集合
    methods: {
        closeChild() {
            this.parentSearchData.bgmId = "";
            this.parentSearchData.bgmName = "";
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        calculatePrice(type, index) {
            var info = this.sendDataInfo.desuWoplandetails[index]
            this.$set(this.sendDataInfo.desuWoplandetails[index], type, this.$common.updataNum(type, info)[type])
            switch (type) {
                case 'orderNum':
                    // 计算销售金额 销售价格*数量
                    this.sendDataInfo.desuWoplandetails[index].psmoney = this.$common.getDecimalInfo(3, NP.times((info.psprice || 0), (info.orderNum || 0)));
                    // 计算采购金额 采购价格*数量
                    this.sendDataInfo.desuWoplandetails[index].cgMoney = this.$common.getDecimalInfo(3, NP.times(info.cgPrice, info.orderNum));
                    break;
                case 'psprice':
                    // 计算销售金额 销售价格*数量
                    this.sendDataInfo.desuWoplandetails[index].psmoney = this.$common.getDecimalInfo(3, NP.times((info.psprice || 0), (info.orderNum || 0)));
                    break;
                case 'cgPrice':
                    // 计算采购金额 采购价格*数量
                    this.sendDataInfo.desuWoplandetails[index].cgMoney = this.$common.getDecimalInfo(3, NP.times(info.cgPrice, info.orderNum));
                    break;
                case 'cgMoney':
                    // 计算采购价格 采购金额/数量
                    this.sendDataInfo.desuWoplandetails[index].cgPrice = !info.cgMoney ? 0 : this.$common.getDecimalInfo(2, NP.divide(info.cgMoney, info.orderNum));
                    break;
                default:
                    break;
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField, flag) {
            setTimeout(() => {
                this.showDialog = false;
            }, 16.7);
            this.seIndex = index;
            this.sField = sField;
            this.DialogVisible = true;
            this.seId = sId;
            this.seType = type
            this.fField = fField
            for (const key in this.sendDataInfo) {
                if (this.sendDataInfo[key] != null && this.sendDataInfo[key] !== "") {
                    this.parentSearchData[key] = this.sendDataInfo[key];
                } else {
                    this.parentSearchData[key] = ""
                }
            }
            if (flag) {
                if (this.sendDataInfo.desuWoplandetails[index][type] != null && this.sendDataInfo.desuWoplandetails[index][type] !== "") {
                    this.parentSearchData[type] = this.sendDataInfo.desuWoplandetails[index][type];
                }
            } else {

                if (this.seType == 'opmName') {
                    this.parentSearchData.opmSalesperson = 1
                } else {
                    delete this.parentSearchData.opmSalesperson
                }
            }
        },
        //检索带回数据
        changeInputModel(val) {
            console.log("返回", val);
            if (val != "" || val != undefined) {
                if (this.seType == 'cmName') {
                    this.showDialog = false;
                    let cmNameFlag = -1;
                    //销售单位
                    this.$http.checkCustomerSale({
                        //校验单位
                        formId: this.formDataList[0].jciId, //表单ID
                        unitId: val.cmId, //单位ID
                    }).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                cmNameFlag = this.dialogList.findIndex(
                                    (item) => item.level == 0
                                );
                                this.showDialog = true;
                            }
                            if (cmNameFlag == -1) {
                                this.parentSearchData.cmId = val.cmId;
                                this.sendDataInfo.cmId = val.cmId;
                                this.sendDataInfo.cmName = val.cmName;
                                this.$http.queryDefaultSales({
                                    ids: [val.cmId]
                                }).then((res) => {
                                    if (res && res.status == 200) {
                                        var valObj = {
                                            ...val,
                                            ...res.result,
                                        }
                                        if (valObj.salesName && valObj.salesId && this.sField.indexOf('salesName') != -1 && this.sField.indexOf('salesId') != -1) {
                                            //对方业务员
                                            this.$http.checkSalesSale({
                                                //校验对方业务员
                                                formId: this.formDataList[0].jciId, //表单ID
                                                salesId: valObj.salesId, //业务员ID
                                            }).then((res) => {
                                                if (res && res.status == 200) {
                                                    let flag = -1;
                                                    if (res.result != null && res.result.length > 0) {
                                                        res.result.forEach(item => {
                                                            this.dialogList.push(item)
                                                        })
                                                        flag = this.dialogList.findIndex((item) => item.level == 0);
                                                        this.showDialog = true;
                                                    }
                                                    if (flag == -1) {
                                                        this.sendDataInfo.salesName = valObj.salesName;
                                                        this.sendDataInfo.salesId = valObj.salesId;
                                                        if (valObj.recName && valObj.recId && this.sField.indexOf('recName') != -1 && this.sField.indexOf('recId') != -1) {
                                                            //收货员
                                                            this.$http.checkRecSalesSale({
                                                                //校验收货员
                                                                formId: this.formDataList[0].jciId, //表单ID
                                                                salesId: valObj.recId, //业务员ID
                                                            }).then((res) => {
                                                                if (res && res.status == 200) {
                                                                    let salesFlag = -1;
                                                                    if (res.result != null && res.result.length > 0) {
                                                                        res.result.forEach(item => {
                                                                            this.dialogList.push(item)
                                                                        })
                                                                        salesFlag = this.dialogList.findIndex((item) => item.level == 0);
                                                                        this.showDialog = true;
                                                                    }
                                                                    if (salesFlag == -1) {
                                                                        this.paramValue(valObj);
                                                                    }
                                                                } else {
                                                                    this.lineMessageBox(res);
                                                                    return false;
                                                                }
                                                            }).catch((rej) => {
                                                                this.lineMessageBox(rej);
                                                            });
                                                        } else {
                                                            this.paramValue(valObj);
                                                        }
                                                    } else {
                                                        this.showDialog = true;
                                                    }
                                                } else {
                                                    this.lineMessageBox(res);
                                                    return false;
                                                }
                                            }).catch((rej) => {
                                                this.lineMessageBox(rej);
                                            });
                                        } else {
                                            this.paramValue(valObj);
                                        }
                                    } else {
                                        this.paramValue(val);
                                    }
                                }).catch((err) => {
                                    this.lineMessageBox(err);
                                })

                            } else {
                                this.showDialog = true;
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.parentSearchData.cmId = "";
                            this.clearValue();
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.parentSearchData.cmId = "";
                        this.clearValue();
                    });
                } else if (this.seType == 'salesName') {
                    this.showDialog = false;
                    //对方业务员
                    this.$http.checkSalesSale({
                        //校验对方业务员
                        formId: this.formDataList[0].jciId, //表单ID
                        salesId: val.salesId, //业务员ID
                    }).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            let flag = -1;
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                flag = this.dialogList.findIndex(
                                    (item) => item.level == 0
                                );
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                this.paramValue(val);
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.clearValue();
                            return false;
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.clearValue();
                    });
                } else if (this.seType == 'opmName') {
                    this.paramValue(val)
                } else if (this.seType == 'coName') {
                    //货主
                    this.$http.checkSuComey({
                        //校验对方业务员
                        formId: this.formDataList[0].jciId, //表单ID
                        coId: val.coId, //货主ID
                    }).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            let flag = -1;
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                flag = this.dialogList.findIndex(item => item.level == 0);
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                this.coId = val.coId;
                                this.sendDataInfo.ormId = this.ormId;
                                this.paramValue(val);
                            } else {
                                this.showDialog = true;
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.clearValue();
                            return false;
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.clearValue();
                    });
                } else if (this.seType == 'caiAddress') {
                    this.paramValue(val)
                } else if (this.seType == 'bgmName') {
                    if (val.expidate == null || val.expidate == "" || val.expidate == undefined) {
                    } else {
                        if (val.expidate < this.$common.getNewDayTime()) {
                            this.tableNextFocus("bgmName", this.seIndex);
                            return this.$message({
                                message: "该品种已过期，不允许销售!",
                                type: "error",
                            });
                        }
                    }
                    var obj = {}
                    for (const key in this.detaislDataInfo) {
                        if (val[key] !== "" && val[key] != undefined && val[key] != null) {
                            this.$set(obj, key, val[key])
                        } else {
                            this.$set(obj, key, this.detaislDataInfo[key])
                        }
                    }
                    this.$set(this.sendDataInfo.desuWoplandetails, this.seIndex, JSON.parse(JSON.stringify(obj)));
                    if (this.fField) {
                        this.tableNextFocus(this.fField, this.seIndex);
                    }
                    this.selectedDetailsIndex = this.seIndex;
                    let refsElTable = this.$refs.mxTableRef;
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuWoplandetails[this.selectedDetailsIndex]);
                } else {
                    this.paramValue(val)
                }
            }
            this.DialogVisible = false; //关闭商品检索窗口
        },
        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        //换行提示
        lineMessageBox(data) {
            console.log(data);

            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            console.log(arr);

            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        // 确认新增
        sendDataAction(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var flag = false
                    var orderIndex = 0
                    var flag1 = false
                    var pspriceIndex = 0
                    this.sendDataInfo.desuWoplandetails.forEach((item, index) => {
                        if ((item.orderNum == 0 || item.orderNum == "") && !flag) {
                            flag = true
                            orderIndex = index
                        }
                        if ((item.psprice == 0 || item.psprice == "") && !flag1) {
                            flag1 = true
                            pspriceIndex = index
                        }
                    })
                    if (flag) {
                        this.selectedDetailsIndex = orderIndex
                        return this.$message.error(`第${this.selectedDetailsIndex + 1}行商品的数量不能为空或为零`)
                    }
                    if (flag1) {
                        this.selectedDetailsIndex = pspriceIndex
                        return this.$message.error(`第${this.selectedDetailsIndex + 1}行商品的销售价格不能为空或为零`)
                    }

                    this.sub()
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.suwoplanAddPlan(sendData);
            } else {
                var responseData = await this.$http.suwoplanUpdPlan(sendData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //取消新增
        initActionBox(formName) {
            this.$confirm("确定取消吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.init();
                    this.$emit("drawerCancel", 0);
                    this.$refs[formName].resetFields();
                })
                .catch(() => { });
        },
        //新增明细
        addDetails(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    //bgmId
                    var flag = false;
                    if (this.sendDataInfo.desuWoplandetails.length > 0) {
                        this.sendDataInfo.desuWoplandetails.forEach((item) => {
                            if (item.bgmCode == "") {
                                flag = true;
                                this.$nextTick(() => {
                                    this.selectedDetailsIndex = Number(
                                        this.sendDataInfo.desuWoplandetails.length - 1
                                    );
                                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                                    let refsElTable = this.$refs.mxTableRef;
                                    refsElTable.clearSelection();
                                    refsElTable.toggleRowSelection(
                                        this.sendDataInfo.desuWoplandetails[
                                        this.selectedDetailsIndex
                                        ]
                                    );
                                });
                            }
                        });
                    }
                    if (flag) {
                        return;
                    }
                    this.sendDataInfo.desuWoplandetails.push({});
                    var index = this.sendDataInfo.desuWoplandetails.length - 1;
                    for (const key in this.detaislDataInfo) {
                        this.$set(
                            this.sendDataInfo.desuWoplandetails[index],
                            key,
                            this.detaislDataInfo[key]
                        );
                    }
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.desuWoplandetails.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.desuWoplandetails[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == "keydown") {
                if (this.sendDataInfo.desuWoplandetails[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    this.selectedDetailsIndex = index + 1;
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.desuWoplandetails[this.selectedDetailsIndex]
                        );
                    });
                    return;
                }
                this.addDetails("sendDataInfo");
                return;
            }
            this.$refs[field][index].focus();
        },
        //删除明细
        deleteDetails() {
            if (this.sendDataInfo.desuWoplandetails.length < 1) {
                this.$message({
                    message: "请先添加明细",
                    type: "error",
                });
                return false;
            }
            this.sendDataInfo.desuWoplandetails.splice(this.selectedDetailsIndex, 1);
            this.selectedDetailsIndex = 0;
        },
        // 初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.totalCount = 0; //总条目数
            this.sendDataInfo.totalMoney = 0; // 总金额
            this.sendDataInfo.totalNumber = 0; // 总数量
            this.sendDataInfo.planDate = this.$moment().valueOf();
            this.sendDataInfo.desuWoplandetails = [];

            // this.dataActionBox.actionType = 0
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.filterMainField();
            this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.checkIsBuyer()
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                // var _this = this
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.ormId = oldData.ormId
                    ? oldData.ormId
                    : JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                    this.mxForm.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    // if (key.jurconfigform[index].isShow == 1)
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

                }
            });
            var arr = [{ entityField: "desuWoplandetails" }];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
            this.showTabs = this.tabForm[0].jciName;
        },
        // 判断是不是采购员
        checkIsBuyer() {
            if (this.dataActionBox.actionType != 0) return;
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            let ormInfo = JSON.parse(sessionStorage.getItem("ormInfo"));
            if (ormInfo.isDefaultopm == 1) {
                if (info.opmSalesperson == 1) {
                    this.sendDataInfo.depName = info.depName;
                    this.sendDataInfo.depId = info.depId;
                    this.sendDataInfo.opmName = info.opmName;
                    this.sendDataInfo.opmId = info.opmId;
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "opmName" ||
                            item.entityField == "depName"
                        )
                            item.isChange = 0;
                    });
                }
            }
        },
        // 输入框切换焦点
        nextFocus(index, fField) {
            if (index >= this.inputel.length - 1) {
                if (this.sendDataInfo.desuWoplandetails.length > 0) {
                }
                this.addDetails("sendDataInfo");
                return;
            }
            if (fField == "keydown") {
                this.addDetails("sendDataInfo");
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.getMainInput() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.el-drawer {
    outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>